export class FlightRouteDto {
  origin?: string;
  originNearAirports?: boolean;
  date?: string;
  destination?: string;
  destinationNearAirports?: boolean;
}
